<template>
  <v-app>
    <navigator @doFold="onedoFold" @wskey="wsSet"></navigator>
    <v-main style="margin-bottom:300px;" :class='[unfold ? "pl80" : "pl312"]' :key="routeName+paramsId">
      <v-card class="child-sticky mx-0 pl-4 d-flex" color="#294A66" tile dark>
        <v-card-actions>
          <v-img 
            v-if="!eachWs&&logoSrc&&logoSrc!=='none'" 
            class="preview-item-file" 
            :src="logoSrc" 
            alt="" width="40px" 
          />
          <v-img
            v-else
            src="../assets/logo/logo.png"
            class="preview-item-file" 
            alt="" width="40px"
          />
          <v-card-text class="py-0">
            <h3 style="color:white;" class="font-weight-bold"><span v-text="basetitle" v-if="basetitle"></span></h3>
            <p class="mr-auto my-0">メンバー {{ members.length }}人 {{ $t('Lid') }}数{{ navlid.length }}</p>
          </v-card-text>
        </v-card-actions>
        <v-card-actions v-if="!(wss && wss.length) || eachWs" class="ml-auto Block2 px-2">
        </v-card-actions>
        <v-card-actions v-if="!(wss && wss.length) || eachWs" class="mt-2" style="background-color:#CCE8FF; border-right: none; border-left: none;">
          <v-btn v-if="page != 'zentei'" rounded style="color:#294A66 !important; background-color:white !important;"
            @click="page = 'zentei'"><v-img width="25px" height="25px"
              src="../assets/svg/information2.svg"></v-img>{{ $t('前提情報') }}</v-btn>
          <v-btn v-if="page == 'zentei'" rounded style="background-color:#294A66 !important;" @click="page = 'zentei'"><v-img
              width="25px" height="25px" src="../assets/svg/information.svg"></v-img>{{ $t('前提情報') }}</v-btn>
          <v-btn v-if="page != 'offline'" rounded style="color:#294A66 !important; background-color:white !important;"
            @click="page = 'offline', content = config.home_meeting, getMtg()"><v-img width="25px" height="25px"
              src="../assets/svg/offline_mtg2.svg"></v-img>スケジュール</v-btn>
          <v-btn v-if="page == 'offline'" rounded outlined style="background-color:#294A66 !important;"
            @click="page = 'offline', content = config.home_meeting, getMtg()"><v-img width="25px" height="25px"
              src="../assets/svg/offline_mtg.svg"></v-img>スケジュール</v-btn>
          <v-btn v-if="page != 'news'" rounded style="color:#294A66 !important; background-color:white !important;"
            @click="page = 'news'"><v-img width="25px" height="25px"
              src="../assets/svg/notification2.svg"></v-img>お知らせ</v-btn>
          <v-btn v-if="page == 'news'" rounded style="background-color:#294A66 !important;" @click="page = 'news'"><v-img
              width="25px" height="25px" src="../assets/svg/notification.svg"></v-img>お知らせ</v-btn>
          <v-btn v-if="page != 'map'" rounded style="color:#294A66 !important; background-color:white !important;"
            @click="page = 'map', setLocate()"><v-img width="25px" height="25px"
              src="../assets/svg/map2.svg"></v-img>地図情報</v-btn>
          <v-btn v-if="page == 'map'" rounded outlined style="background-color:#294A66 !important;"
            @click="page = 'map', setLocate()"><v-img width="25px" height="25px"
              src="../assets/svg/map.svg"></v-img>地図情報</v-btn>
          <router-link :to="$route.params.id ? '/dashboard?id='+$route.params.id : '/dashboard'" style="text-decoration:none;margin-left:8px">
            <v-btn rounded style="color:#294A66 !important; background-color:white !important;"><v-img width="25px"
                height="25px" src="../assets/svg/each_lid2.svg"></v-img>各{{ $t('Lid') }}情報</v-btn>
          </router-link>
        </v-card-actions>
      </v-card>
      <v-card elevation="0" class="text-center font-weight-bold" tile height="48px" color="lava" style="width:100% !important;" v-if="!isAuthed" @click="authModal=true">
        <p class="pt-3 mx-auto" style="color: white; font-size: 16px;">現在ログインしていません。ここをタッチして、参加しましょう！</p>
      </v-card>
      <v-container>
        <div class="mx-4" style="border-bottom:solid #707070;">
          <p class="d-flex mb-2" v-if="page == 'zentei'"><span class="mr-auto">{{ (wss && wss.length && !eachWs) ? "ホーム" : $t('前提情報') }}</span><span
              class="cloud--text text-caption">更新日時</span><span class="cloud--text text-caption"
              v-if="config.home_preinfoTime" v-text="config.home_preinfoTime.toDate().toLocaleString()"></span><span
              class="cloud--text text-caption ml-2" v-else>未登録</span></p>
          <p class="d-flex mb-2" v-if="page == 'offline'">
            <span class="mr-auto">スケジュール</span>
            <span class="cloud--text text-caption" v-if="false">更新日時</span>
            <span class="cloud--text text-caption" v-if="false&&config.home_meetingTime" v-text="config.home_meetingTime.toDate().toLocaleString()"></span>
            <span class="cloud--text text-caption ml-2" v-else-if="false">未登録</span></p>
          <p class="d-flex mb-2" v-if="page == 'news'"><span class="mr-auto">お知らせ</span><span
              class="cloud--text text-caption">更新日時</span><span class="cloud--text text-caption"
              v-if="config.home_newsTime" v-text="config.home_newsTime.toDate().toLocaleString()"></span><span
              class="cloud--text text-caption ml-2" v-else>未登録</span></p>
          <p class="d-flex mb-2" v-if="page == 'map'"><span class="mr-auto">地図情報</span></p>
        </div>
        <div v-if="page === 'zentei' || page == 'news'">
          <!-- タイル一覧（環境変数で有効化された時のみ） -->
          <tile class="mt-3" v-if="showTileAboveRich" :key="eachWs?'tile-'+eachWs.id:'tile'" :wsId="eachWs&&eachWs.id" :tileEnabled="!!eachWs||!wss.length" />
          <RichViewAndEditor :lidId="lidId" :wsId="$route.params.id" :wsTitle="basetitle" :key="page + $route.params.id + 'rich'"
            :pageType="page" @updateDate="(date) => { contentUpdatedAt = date }"></RichViewAndEditor>
          <PDFViewAndSelector :lidId="lidId" :wsId="$route.params.id" :key="page + $route.params.id + 'pdf'"
            :pageType="page"></PDFViewAndSelector>

          <!-- アイデア募集中の取り組み -->
          <div class="mt-3" v-if="wss && wss.length && !eachWs">
            <h2>
              {{ $t('アイデア') }}{{ $t('募集中の取組') }}
            </h2>
            <v-row class="my-2">
              <v-col v-for="ws in wss" :key="ws.sort">
                <router-link :to="'/workspace/' + ws.id" style="text-decoration:none;">
                  <v-card max-width="350px" tile class="mx-auto pa-1 rounded-lg" height="100%" color="#F5F5F5">
                    <v-img
                      v-if="ws.wsImage_large || ws.wsImage" :src="ws.wsImage_large || ws.wsImage" height="200" ></v-img>
                    <v-img v-else src="../assets/png/1106.png" height="250"></v-img>
                    <v-card-title class="mt-auto font-weight-regular pa-3 text-center" style="font-size:24px;">
                      {{ws.title}}
                    </v-card-title>
                      <!--ワークスペース概要-->
                    <v-card-text class="font-weight-regular ma-0 px-4 pt-0 pb-2" style="max-height:20%; font-size:16px;" v-if="ws.summary" v-dompurify-html="ws.summary"></v-card-text>
                  </v-card>
                </router-link>
              </v-col>
            </v-row>
            <div v-if="config.setting&&config.setting.torikumiNoShitaNoText" v-html="config.setting.torikumiNoShitaNoText"></div>
          </div>
          <!-- タイル一覧 -->
          <tile class="mt-3" v-if="!showTileAboveRich" :key="eachWs?'tile-'+eachWs.id:'tile'" :wsId="eachWs&&eachWs.id" :tileEnabled="!!eachWs||!wss.length" />
        </div>
        <div class="mx-4 mt-2 mb-12 qimg" v-else-if="page == 'offline'">
          <div class="my-3 d-flex align-center">
            <h3 class="mr-auto">イベントカレンダー</h3>
            <v-btn class="deepAqua" rounded dark @click="neweditMtg(), mtgId = 'new', editMtg = true" v-if="isAdmin"> 新規予定追加</v-btn>            
          </div>
          <v-row>
            <div class="mx-auto my-2">
              <v-sheet tile height="6vh" color="grey lighten-3" class="d-flex align-center">
                <v-btn outlined small class="ma-4" @click="setToday">
                  今日
                </v-btn>
                <v-btn icon @click="$refs.calendar.prev()">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn icon @click="$refs.calendar.next()">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
                <v-toolbar-title v-if="$refs.calendar">{{ $refs.calendar.title }}</v-toolbar-title>
              </v-sheet>
              <v-sheet width="120vh" height="60vh">
                <v-calendar ref="calendar" v-model="focus" :events="mtgs.map((oneno) => {
                    return {
                      id: oneno.sort, name: oneno.mtgTitle, start: oneno.mtgDateStart, end: oneno.mtgDateEnd, color: 'red', timed: false
                    }
                  })" :event-color="getEventColor" locale="ja-jp"
                  :day-format="(timestamp) => new Date(timestamp.date).getDate()"
                  :month-format="(timestamp) => (new Date(timestamp.date).getMonth() + 1) + ' /'" @click:event="showEvent"
                  @change="getEvents"></v-calendar>
              </v-sheet>
            </div>
            <v-col cols="12" v-for="mtg in mtgs" :key="mtg.sort">
              <v-card class="my-2" color="sky" @click="showMtgContent(mtg)">
                <v-row>
                  <v-col cols="3" class="pa-6 d-flex">
                    <v-img src="../assets/とにかく始める_議論.svg" width="70%" class="ma-auto"></v-img>
                  </v-col>
                  <v-col cols="9" class="d-flex flex-column text-left">
                    <v-card-actions>
                      <v-chip class="white--text" small color="deepAlgae" v-if="mtg && mtg.mtgIs === 'before'">募集開始前</v-chip>
                      <v-chip class="white--text" small color="deepLava" v-else-if="mtg && mtg.mtgIs === 'now'">募集中</v-chip>
                      <v-chip class="white--text" small color="cloud" v-else-if="mtg && mtg.mtgIs === 'after'">募集終了</v-chip>
                      <v-chip class="white--text" small color="abyss" v-else-if="mtg && mtg.mtgIs === 'report'">開催報告</v-chip>
                      <h2 class="ml-2" v-if="mtg && mtg.mtgTitle" v-text="mtg.mtgTitle"></h2>
                      <v-spacer></v-spacer>
                      <v-menu top v-if="isAdmin && mtg && mtg.sort">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn class="" color="#2B2B2B" @click="preeditMtg(mtg)" icon v-bind="attrs" v-on="on"
                            style="font-family: mplus-2c-bold;">
                            <v-icon>mdi-dots-vertical</v-icon>
                          </v-btn>
                        </template>
                        <v-list class="pb-0 pt-0" v-if="mtg">
                          <v-list-item @click="editMtg = true">
                            <v-list-item-title>編集</v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="deleteMtg(mtg.sort)">
                            <v-list-item-title>削除</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-card-actions>
                    <v-card-actions class="d-flex flex-column">
                      <p class="mb-0 mr-auto" style="font-size:13px">担当課：<span v-if="mtg && mtg.mtgInCharge" v-text="mtg.mtgInCharge"></span></p>
                      <p class="mb-0 mr-auto" style="font-size:13px">実施日:{{ dateFormatter(mtg.mtgDateStart, mtg.mtgDateEnd) }}</p>
                      <p class="mb-0 pa-2" v-if="mtg && mtg.mtgSummary" v-text="mtg.mtgSummary" style="font-size:15px; max-height: 150px; width:100%; overflow: hidden;"></p>
                    </v-card-actions>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" v-if="mtgs.length === 0">
              <p class="text-center">スケジュール情報が登録されていません。</p>
            </v-col>
          </v-row>
        </div>
        <div v-else-if="page == 'map'" class="mt-2 mb-12">
          <l-map ref="map" @click="addMarker" style="height:600px; width:90%; z-index:0" :zoom="15"
            :center="[locate.lat, locate.lng]" class="mx-auto">
            <l-tile-layer :url="'http://{s}.tile.osm.org/{z}/{x}/{y}.png'" :attribution="attribution"></l-tile-layer>
            <Vue2LeafletMarkerCluster>
              <l-marker v-for="(item, index) in showedIdeaInMap_dict" :key="index"
                :lat-lng="[item.latlngInputLat, item.latlngInputLng]" :icon="item.icon">
                <l-popup :options="{ offset: [3, -26] }">
                  <div class="primary--text">{{ item.content }} ({{ item.timeday }}:{{ namelist[item.author] }})</div>
                  <!-- <div v-for="(title, index) in marker.titles"
                :key="'tit-'+index">
                  <a :href="title.uri" target="_blank">{{title.title}}</a>
                </div> -->
                </l-popup>
              </l-marker>
            </Vue2LeafletMarkerCluster>
            <Vue2LeafletMarkerCluster>
              <!-- config.placeLayerに配置した情報提供用の位置情報ピン -->
              <l-marker v-for="(place, index) in config.placeLayer" :key="index" :lat-lng="[place.lat, place.lon]"
                :icon="getIconWithColor(place.color, 'pin')">
                <l-popup :options="{ offset: [13, -24] }">
                  <div>
                    <h3 class="primary--text">{{ place.name }}</h3>
                    <p v-if="place.desc" class="body1">{{ place.desc }}</p>
                  </div>
                </l-popup>
              </l-marker>
            </Vue2LeafletMarkerCluster>
          </l-map>
          <div class="sky ma-2 pa-1 rounded-lg">
            <h3 class="text-center lnk--text">{{ $t('アイデア') }}の位置情報表示</h3>
            <v-row class="my-2">
              <v-col cols="3" v-for="(item, index) in navlid" :key="index">
                <v-checkbox v-model="mapLid" :label="item.title" :value="item.id" hide-details multiple></v-checkbox>
              </v-col>
            </v-row>
            <div class="d-flex">
              <v-btn class="mx-auto my-2 white--text" color="deepAqua" :disabled="mapLid.length === 0" rounded
                @click="getIdea()">表示</v-btn>
            </div>
          </div>
        </div>
        <p v-else class="text-center mt-16 ink--text">管理者が自由に編集できるページです。<br>右下部のえんぴつマークの編集ボタンを押して、メンバーの皆さんに共有しましょう！</p>
      </v-container>
    </v-main>
    <!--フッター-->
    <v-footer :class='[unfold ? "pl80" : "pl312"]' padless style="position:fixed; bottom:0px; width:100%; z-index:6;">
      <v-card v-if="!(wss&&wss.length) || eachWs" class="py-0 my-0 mx-auto lidchips" width="100%">
        <v-row>
          <v-col cols="3">
            <p class="py-2 my-0 pl-4">募集中の{{ $t('アイデア') }}出しテーマ一覧</p>
            <p class="text-caption py-0 my-0 pl-4">表示されているテーマをクリックして,</p>
            <p class="text-caption py-0 my-0 pl-4">{{ $t('アイデア') }}を投稿しよう！</p>
          </v-col>
          <v-col cols="9">
            <v-chip-group class="mx-2 pb-2" active-class="primary--text" show-arrows>
              <v-chip v-for="item in navlid" :key="item.id" :to="'/lid/' + item.id + '/idea'" label outlined elevation="30"
                style="border-left: 0.3rem solid #294A66; border-top: 0.1rem solid #000000; border-right: 0.1rem solid #000000; border-bottom: 0.1rem solid #000000;"
                large>
                {{ item.title }}
              </v-chip>
            </v-chip-group>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="flex" flat tile color="#dcdcdc">
        <div class="py-0 text-center" v-if="config && config.inquiry" style="width: 100%;">
          <p class="mb-0">お問い合わせ：<span v-text="config.inquiry"></span></p>
          <a v-if="config && config.inquiryUrl" :href="config.inquiryUrl" target="_blank" rel="noopener">{{ config.inquiryUrl }}</a>
        </div>
        <v-card-text class="py-0 text-center">
          <span>&copy;</span> {{ new Date().getFullYear() }} — <strong>Liquitous</strong>
        </v-card-text>
      </v-card>
    </v-footer>

    <div>
      <!--ワークショップカードの編集・追加-->
      <v-dialog v-model="editMtg" width="80%">
        <v-card class="pa-4">
          <v-card-actions>
            <h3>ワークショップ詳細設定</h3>
            <v-spacer></v-spacer>
            <v-icon @click="editMtg = false" x-large>mdi-close</v-icon>
          </v-card-actions>
          <div class="d-flex flex-column overflow-y-auto overflow-x-hidden" style="height:70vh;">
            <p style="color:#294A66;">ワークショップタイトル</p>
            <v-textarea v-model="mtgTitle" outlined label="" value="" rows="1"></v-textarea>
            <p style="color:#294A66;">概要</p>
            <v-textarea v-model="mtgSummary" outlined label="" value="" rows="10"></v-textarea>
            <p style="color:#294A66;">担当課</p>
            <v-textarea v-model="mtgInCharge" outlined label="" value="" rows="1"></v-textarea>
            <p style="color:#294A66;">リンク</p>
            <v-textarea v-model="mtgLinkFont" outlined label="" value="" rows="1"></v-textarea>
            <v-row>
              <v-col cols="3">
                <p style="color:#294A66;">実施開始日時</p>
                <VueCtkDateTimePicker v-model="mtgDateStart" label="開始日時"
                  :format="mtgAllDay ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm'" :formatted="mtgAllDay ? 'll' : 'lll'"
                  :only-date="mtgAllDay" :no-header=true locale="ja" :noClearButton=true></VueCtkDateTimePicker>
              </v-col>
              <v-col cols="3">
                <p style="color:#294A66;">実施終了日時</p>
                <VueCtkDateTimePicker v-model="mtgDateEnd" label="終了日時"
                  :format="mtgAllDay ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm'" :formatted="mtgAllDay ? 'll' : 'lll'"
                  :only-date="mtgAllDay" :no-header=true locale="ja" :noClearButton=true></VueCtkDateTimePicker>
              </v-col>
              <v-col cols="1">
                <!-- mtgAllDay -->
                <p style="color:#294A66;">終日</p>
                <v-checkbox v-model="mtgAllDay" :true-value=true :false-value=false hide-details class="pa-0 ma-0"
                  @change="switchMtgAllDay"></v-checkbox>
              </v-col>
              <v-col cols="4">
                <p style="color:#294A66;">募集可否</p>
                <v-radio-group v-model="mtgIs">
                  <v-radio label="募集中" value="now"></v-radio>
                  <v-radio label="募集終了" value="after"></v-radio>
                  <v-radio label="開催報告" value="report"></v-radio>
                </v-radio-group>
                <v-col cols="5" class="py-2">
                </v-col>
              </v-col>
            </v-row>
            <v-card-actions>
              <h3></h3>
              <v-spacer></v-spacer>
              <v-btn v-if="mtgId == 'new'" class="rounded-pill pa-6 mr-4 white--text"
                color="#008CFF" @click="editMtg = false, updateMtg()"
                :disabled="mtgTitle.length == 0 || mtgSummary.length == 0 || mtgDateStart.length == 0 || mtgDateEnd.length == 0">新規追加</v-btn>
              <v-btn v-else class="rounded-pill px-2 mr-4 white--text" color="#008CFF"
                @click="editMtg = false, updateMtg()"
                :disabled="mtgTitle.length == 0 || mtgSummary.length == 0 || mtgDateStart.length == 0 || mtgDateEnd.length == 0">変更内容を保存</v-btn>
            </v-card-actions>
          </div>
        </v-card>
      </v-dialog>
      <!--サインイン画面-->
      <v-dialog v-model="authModal" width="400px" height="60%">
        <auth-view defaultView="chooseauth" @closeModal="closeAuthModal">
        </auth-view>
      </v-dialog>
      <v-dialog v-model="mtgContent" width="85vw" height="90vh">
        <v-card color="white">
          <v-card-actions class="pa-2">
            <v-chip class="white--text" small color="deepAlgae" v-if="mtgIs === 'before'">募集開始前</v-chip>
            <v-chip class="white--text" small color="deepLava" v-else-if="mtgIs === 'now'">募集中</v-chip>
            <v-chip class="white--text" small color="cloud" v-else-if="mtgIs === 'after'">募集終了</v-chip>
            <v-chip class="white--text" small color="abyss" v-else-if="mtgIs === 'report'">開催報告</v-chip>
            <h3 class="ml-2">スケジュール情報</h3>
            <v-spacer></v-spacer>
            <v-icon @click="mtgContent = false" x-large>mdi-close</v-icon>
          </v-card-actions>
          <v-card-actions style="height:80vh;">
            <v-row style="height:100%">
              <v-col cols="5" class="d-flex flex-column">
                <h1 v-if="mtgTitle" v-text="mtgTitle" class="my-2 text-center"></h1>
                <div class="d-flex flex-column text-center">
                  <p class="mb-0">担当課：<span v-if="mtgInCharge" v-text="mtgInCharge"></span></p>
                  <!-- mtgDateStartとmtgDateEndが同じ場合は重複するmtgDateStartのみ、異なる場合はmtgDateStart～mtgDateEndと表示 -->
                  <p class="mb-0">実施日:{{ dateFormatter(mtgDateStart, mtgDateEnd) }}</p>
                  <div class="" v-if="mtgLinkFont" style="max-width:100%; max-height:60px;">
                    詳細URL:<a :href="mtgLinkFont" target="_blank">{{ mtgLinkFont.slice(0, 30) + "..." }}</a>
                  </div>
                </div>
                <v-img src="../assets/とにかく始める_議論.svg" alt="スケジュール画像" style="width:90%;height:60%;"
                  class="mx-auto"></v-img>
              </v-col>
              <v-col cols="7" style="height:100%">
                <h3>【概要】</h3>
                <p v-if="mtgSummary" v-text="mtgSummary" style="height:90%;" class="overflow-x-hidden overflow-y-auto mb-0"></p>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-app>
</template>

<script>
import Vue from 'vue'
import firebase from 'firebase'
import navigator from '../components/navigator.vue'
// import authView from '../components/auth/authView.vue';
const authView = () => import('../components/auth/authView.vue')
const upImage = () => import('../components/upImage.vue')
import tile from '../components/tile.vue'
import VueDOMPurifyHTML from 'vue-dompurify-html'
Vue.use(VueDOMPurifyHTML, {
  default: {
    ADD_TAGS: ['iframe'], // this one whitelists Youtube
  },
})
import { config } from 'process'
import RichViewAndEditor from '../components/RichViewAndEditor.vue'
import PDFViewAndSelector from '../components/PDFViewAndSelector.vue';
import axios from "axios";
import VueAxios from "vue-axios";
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';

Vue.use(VueAxios, axios)

import VueMq from 'vue-mq'
Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    sp: 959,
    pc: 960
  },
  defaultBreakpoint: 'pc' // customize this for SSR
})

import 'leaflet/dist/leaflet.css'
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'
import L from 'leaflet';
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});
export default {
  data: () => ({
    db: null,
    content: "",
    now: "",
    showedIdeaInMap_dict: [],
    idea: [],
    mapLid: [],
    mtgs: [],
    mtgId: "new",
    editMtg: false,
    imgpopup: false,
    mtgContent: false,
    authModal: false,
    mtgTitle: "",
    mtgSummary: "",
    mtgInCharge: "",
    mtgLinkFont: "",
    mtgDateStart: "",
    mtgDateEnd: "",
    mtgAllDay: true,
    mtgIs: "now",
    page: 'zentei',
    contentUpdatedAt: '',
    unfold: false,
    attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    data_location_lat: Number(process.env.VUE_APP_LOCATION_LAT || 35.6813320349034),
    data_location_lng: Number(process.env.VUE_APP_LOCATION_LNG || 139.76716771167693),
    latlngInput: {},
    markers: { lat: 0, lng: 0 },
    locate: { lat: 0, lng: 0 },
    events: [],
    focus: "",
    pjEditorOption: {
      modules: {
        toolbar: [
          [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
          //[{ 'font': [] }],
          //[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
          ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
          //['blockquote', 'code-block'],
          //[{ 'header': 1 }, { 'header': 2 }],               // custom button values
          //[{ 'list': 'ordered'}, { 'list': 'bullet' }],
          //[{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
          //[{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
          [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
          [{ 'align': [] }],
          ['linkFont'],
          //['clean'] 
          ['image', 'video'],                                  // remove formatting button
        ],
      }
    },
    home_preinfo: '',
    showTileAboveRich: process.env.VUE_APP_FEAT_SHOW_LID_TILE_ABOVE_RICH == '1',
  }),
  name: 'Home',
  components: {
    navigator,
    // upImage,
    tile,
    authView,
    LMap,
    LTileLayer,
    RichViewAndEditor,
    PDFViewAndSelector,
    LMarker,
    LPopup,
    Vue2LeafletMarkerCluster,
    VueCtkDateTimePicker,
  },
  created() {
    this.db = firebase.firestore() // dbインスタンスを初期化
  },
  mounted() {
    if (this.$mq === 'sp') {
      if (this.$route.name === "workspace") {
        this.$router.replace({ name: 'sp_workspace', query: { ...this.$route.params, ...this.$route.query }})
      } else {
        this.$router.replace({ name: 'sp_home', query: { ...this.$route.params, ...this.$route.query }})
      }
    }
    this.markers = { lat: this.data_location_lat, lng: this.data_location_lng }
    this.locate = { lat: this.data_location_lat, lng: this.data_location_lng }
    if (this.$route.query.page === "offline"){
      this.page = "offline"
      this.getMtg()
    }
    if (this.$route.query.page === "zentei") this.page = "zentei"
    if (this.$route.query.page === "news") this.page = "news"
  },
  computed: {
    paramsId() {
      return this.$route.params.id;
    },
    routeName() {
      return this.$route.name;
    },
    lidId(){
      let el = "ws"
      if(this.$route.name==="home") el = "home"
      return el
    },
    members() {
      return this.$store.state.members
    },
    namelist() {
      return this.$store.state.namelist
    },
    isAdmin() {
      return this.$store.state.isAdmin
    },
    navlid(){
      //公開Lid（フォルダに属す属さない関係なく）
      //console.log(this.$store.state.lid)
      let navlid = []
      this.$store.getters.navlid.forEach((lid)=>{
        if (lid.isfolder) {
          navlid = navlid.concat(lid.childlids)
        } else {
          navlid.push(lid)
        }
      })
      if (this.eachWs&&this.eachWs.lids) navlid = navlid.filter((el) => this.eachWs.lids.includes(el.id))
      return navlid
    },
    alid() {
      return this.$store.state.alid
    },
    wss() {
      return this.$store.getters.wss;
    },
    eachWs() {
      let id = this.$route.params.id;
      if (id) {
        return this.wss.find((el) => el.id === id);
      } else {
        return null
      }
    },
    config() {
      return this.eachWs ? this.eachWs : this.$store.state.config
    },
    basetitle() {
      return this.config.title
    },
    isAuthed() {
      return this.$store.state.auth?.isAuthed;
    },
    logoSrc() {
      return this.$store.state.logoSrc;
    },
  },
  watch: {
    eachWs: {
      handler: function (val) {
        if (!val) {
          this.page = 'zentei'
        }
      },
    },
    // mtgDateStart, mtgDateEndの整合性をチェック ちなみに型は  
    mtgDateStart: function (val) {
      // val==""の場合は何もしない（追加後のリセット）
      if (val === "") return
      if (this.mtgDateEnd === "") {
        if (this.mtgAllDay) {
          // '2023-05-19'のような値 同じ日に設定
          this.mtgDateEnd = val
        } else {
          // '2023-05-19 17:02'のような値 同じ日の1時間後に設定。ただ1時間足して次の日になる場合は23:59
          // つまりvalの値から時刻の部分を取り出し、23時であれば23:59、それ以外は1時間足す
          const hour = Number(val.slice(11, 13))
          if (hour === 23) {
            this.mtgDateEnd = val.slice(0, 11) + "23:59"
          } else {
            this.mtgDateEnd = val.slice(0, 11) + ("0" + (hour + 1)).slice(-2) + val.slice(13)
          }
        }
      } else if (new Date(val) > new Date(this.mtgDateEnd)) {
        if (this.mtgAllDay) {
          // '2023-05-19'のような値 同じ日に設定
          this.mtgDateEnd = val
        } else {
          // '2023-05-19 17:02'のような値 同じ日の1時間後に設定。ただ1時間足して次の日になる場合は23:59
          // つまりvalの値から時刻の部分を取り出し、23時であれば23:59、それ以外は1時間足す
          const hour = Number(val.slice(11, 13))
          if (hour === 23) {
            this.mtgDateEnd = val.slice(0, 11) + "23:59"
          } else {
            this.mtgDateEnd = val.slice(0, 11) + ("0" + (hour + 1)).slice(-2) + val.slice(13)
          }
        }
      }
    },
    mtgDateEnd: function (val) {
      // mtgDateStartの逆。挙動の説明はそちらを参照
      if (val === "") return
      if (this.mtgDateStart === "") {
        if (this.mtgAllDay) {
          this.mtgDateStart = val
        } else {
          const hour = Number(val.slice(11, 13))
          if (hour === 0) {
            this.mtgDateStart = val.slice(0, 11) + "00:00"
          } else {
            this.mtgDateStart = val.slice(0, 11) + ("0" + (hour - 1)).slice(-2) + val.slice(13)
          }
        }
      } else if (new Date(val) < new Date(this.mtgDateStart)) {
        if (this.mtgAllDay) {
          this.mtgDateStart = val
        } else {
          const hour = Number(val.slice(11, 13))
          if (hour === 0) {
            this.mtgDateStart = val.slice(0, 11) + "00:00"
          } else {
            this.mtgDateStart = val.slice(0, 11) + ("0" + (hour - 1)).slice(-2) + val.slice(13)
          }
        }
      }
    },
  },
  methods: {
    wsSet(el) {
      if(this.page==="offline") this.getMtg()
      if(this.page==="map") this.showedIdeaInMap_dict = []
    },
    switchMtgAllDay() {
      // mtgDateStart, mtgDateEndの整合性をチェック ちなみに型は  
      if (this.val === true) {
        // 終日にする場合は時刻を00:00にする
        this.mtgDateStart = this.mtgDateStart && this.mtgDateStart.slice(0, 10)
        this.mtgDateEnd = this.mtgDateEnd && this.mtgDateEnd.slice(0, 10)
      } else {
        // 終日にしない場合は時刻を23:59にする
        this.mtgDateStart = this.mtgDateStart && this.mtgDateStart.slice(0, 10) + " 00:00"
        this.mtgDateEnd = this.mtgDateEnd && this.mtgDateEnd.slice(0, 10) + " 23:59"
      }
    },
    dateFormatter(start, end) {
      const yearStart = start.slice(0, 4)
      const monthStart = start.slice(5, 7).replace(/^0+/, '')
      const dayStart = start.slice(8, 10).replace(/^0+/, '')
      const hourStart = start.slice(11, 13).replace(/^0+/, '')
      const minuteStart = start.slice(14, 16).replace(/^0+/, '')
      const yearEnd = end.slice(0, 4)
      const monthEnd = end.slice(5, 7).replace(/^0+/, '')
      const dayEnd = end.slice(8, 10).replace(/^0+/, '')
      const hourEnd = end.slice(11, 13).replace(/^0+/, '')
      const minuteEnd = end.slice(14, 16).replace(/^0+/, '')
      if (!hourStart.length || !minuteStart.length) {
        // 終日の場合
        if (start.slice(0, 10) == end.slice(0, 10)) {
          // 日時が同じ場合なので、終了の日付は省略
          return yearStart + "年" + monthStart + "月" + dayStart + "日 終日"
        } else if (yearStart == yearEnd && monthStart == monthEnd) {
          // 年と月が同じ場合は重複する年と月を省略
          return yearStart + "年" + monthStart + "月" + dayStart + "日 - " + dayEnd + "日"
        } else if (yearStart == yearEnd) {
          // 年が同じ場合は重複する年を省略
          return yearStart + "年" + monthStart + "月" + dayStart + "日 - " + monthEnd + "月" + dayEnd + "日"
        } else {
          // 年が異なる場合は年月日をすべて表示
          return yearStart + "年" + monthStart + "月" + dayStart + "日 - " + yearEnd + "年" + monthEnd + "月" + dayEnd + "日"
        }
      } else {
        // 終日でない場合
        if (start.slice(0, 10) == end.slice(0, 10)) {
          // 日時が同じ場合なので、終了の日付は省略
          return yearStart + "年" + monthStart + "月" + dayStart + "日 " + hourStart + ":" + minuteStart + " - " + hourEnd + ":" + minuteEnd
        } else if (yearStart == yearEnd && monthStart == monthEnd) {
          // 年と月が同じ場合は重複する年と月を省略
          return yearStart + "年" + monthStart + "月" + dayStart + "日 " + hourStart + ":" + minuteStart + " - " + dayEnd + "日 " + hourEnd + ":" + minuteEnd
        } else if (yearStart == yearEnd) {
          // 年が同じ場合は重複する年を省略
          return yearStart + "年" + monthStart + "月" + dayStart + "日 " + hourStart + ":" + minuteStart + " - " + monthEnd + "月" + dayEnd + "日 " + hourEnd + ":" + minuteEnd
        } else {
          // 年が異なる場合は年月日をすべて表示
          return yearStart + "年" + monthStart + "月" + dayStart + "日 " + hourStart + ":" + minuteStart + " - " + yearEnd + "年" + monthEnd + "月" + dayEnd + "日 " + hourEnd + ":" + minuteEnd
        }
      }
    },
    neweditMtg() {
      this.mtgId = ""
      this.mtgTitle = ""
      this.mtgSummary = ""
      this.mtgIs = ""
      this.mtgLinkFont = ""
      this.mtgInCharge = ""
      this.mtgDateStart = ""
      this.mtgDateEnd = ""
      this.mtgAllDay = true
      this.mtgId = ""
      //console.log("editpew",this.mtgId)
    },
    setToday() {
      this.focus = ''
    },
    preeditMtg(mtg) {
      this.mtgId = mtg.id
      this.mtgTitle = mtg.mtgTitle
      this.mtgSummary = mtg.mtgSummary
      this.mtgIs = mtg.mtgIs
      this.mtgLinkFont = mtg.mtgLinkFont
      this.mtgInCharge = mtg.mtgInCharge
      // this.mtgAllDay=!(mtg?.mtgDateStart?.length>10)
      this.mtgDateStart = mtg.mtgDateStart
      this.mtgDateEnd = mtg.mtgDateEnd
      this.mtgId = mtg.sort
      //console.log("editpew",this.mtgId)
    },
    updateMtg() {
      //console.log("mtg",this.mtgId)
      this.today()
      const self = this
      let name = this.now
      if (this.mtgId != "new") name = this.mtgId
      //console.log("mtg編集",name,this.mtgId,this.mtgTitle,this.mtgSummary,this.mtgDateStart,this.mtgDateEnd,this.mtgIs,this.mtgLinkFont,this.mtgInCharge)
      let collection = this.db.collection("0").doc("config").collection("mtg").doc(name)
      if (this.eachWs) collection = this.db.collection("0").doc("config").collection("ws").doc(this.$route.params.id).collection("mtg").doc(name)
      collection.set({
        isActive: true,
        mtgTitle: self.mtgTitle,
        mtgSummary: self.mtgSummary,
        mtgDateStart: self.mtgDateStart,
        mtgDateEnd: self.mtgDateEnd,
        mtgIs: self.mtgIs,
        mtgLinkFont: self.mtgLinkFont || "",
        mtgInCharge: self.mtgInCharge,
        updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
        sort: name
      }, { merge: true }).then(function (docRef) {
        // 保存に成功した時
        //console.log("Document written with ID: ", self.mtgTitle)
        self.editMtg = false
        self.getMtg()
        if (self.eachWs){
          self.$store.dispatch('setConfigNotify', ({ title: "スケジュール情報更新", content: "スケジュール情報が更新されました。", address: "all", lidid: "workspace", pjid: self.eachWs.id, type: 2, tag: "ホーム" }))
          this.db.collection("0").doc("config").collection("ws").doc(this.eachWs.id).set({
            home_meetingTime: firebase.firestore.FieldValue.serverTimestamp(),
          },{ merge: true })
          .then(function (docRef) {
            // 保存に成功した時
            //console.log("Document written with ID: ");
            self.$store.dispatch("setHomeTime", {
              type: "offline",
              date: firebase.firestore.Timestamp.fromDate(new Date())
            });
          })
        }
        else self.$store.dispatch('setConfigNotify', ({ title: "スケジュール情報更新", content: "スケジュール情報が更新されました。", address: "all", type: 2, tag: "ホーム" }))
        self.mtgTitle = ""
        self.mtgSummary = ""
        self.mtgDateStart = ""
        self.mtgDateEnd = ""
        self.mtgAllDay = true
        self.mtgIs = ""
        self.mtgLinkFont = ""
        self.mtgInCharge = ""
      }).catch(function (error) {
        // 保存に失敗した時
        //alert("エラーが発生しました。恐れ入りますがもう一度操作をやり直してみてください。なお、投稿できる写真のサイズは1MBまでです。")
        console.error("Error adding document:", error);
      })
    },
    deleteMtg(id) {
      const self = this
      let collection = this.db.collection("0").doc("config").collection("mtg").doc(id)
      if (this.eachWs) collection = this.db.collection("0").doc("config").collection("ws").doc(this.$route.params.id).collection("mtg").doc(id)
      collection.set({
        isActive: false,
      }, { merge: true }).then(function (docRef) {
        // 保存に成功した時
        //console.log("Document delete with ID: ",id)
        self.editMtg = false
        self.getMtg()
      }).catch(function (error) {
        // 保存に失敗した時
        console.error("Error adding document:", error);
      })
    },
    getMtg() {
      let self = this
      self.mtgs = []
      let collection = this.db.collection("0").doc("config").collection("mtg").orderBy("sort", "desc")
      if (this.eachWs) collection = this.db.collection("0").doc("config").collection("ws").doc(this.$route.params.id).collection("mtg").orderBy("sort", "desc")
      collection.get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let oneno = doc.data()
            //console.log("mtg",oneno)
            if (oneno.isActive) self.mtgs.push(oneno)
          })
        })
    },
    showEvent(event) {
      const id = event.eventParsed.input.id;
      const mtg = this.mtgs.find((mtg) => mtg.sort === id);
      this.showMtgContent(mtg);
    },
    showMtgContent(mtg) {
      // mtgTitle=mtg.mtgTitle,mtgSummary=mtg.mtgSummary,mtgIs=mtg.mtgIs,mtgLinkFont=mtg.mtgLinkFont,mtgInCharge=mtg.mtgInCharge,mtgId = mtg.sort,mtgContent=true
      this.mtgTitle = mtg.mtgTitle
      this.mtgSummary = mtg.mtgSummary
      this.mtgIs = mtg.mtgIs
      this.mtgLinkFont = mtg.mtgLinkFont
      this.mtgInCharge = mtg.mtgInCharge
      this.mtgAllDay = !(mtg?.mtgDateStart?.length > 10)
      this.mtgDateStart = mtg.mtgDateStart
      this.mtgDateEnd = mtg.mtgDateEnd
      this.mtgId = mtg.sort
      this.mtgContent = true
    },
    addMarker(event) {
      //console.log(event.latlng)
      //this.markers.push(event.latlng);
    },
    setLocate() {
      if (!this.eachWs && this.config && this.config.location) {
        this.locate.lat = this.config.location.lat
        this.locate.lng = this.config.location.lng
        this.markers.lat = this.config.location.lat
        this.markers.lng = this.config.location.lng
      }
      if (this.eachWs && this.eachWs && this.eachWs.location) {
        this.locate.lat = this.eachWs.location.lat
        this.locate.lng = this.eachWs.location.lng
        this.markers.lat = this.eachWs.location.lat
        this.markers.lng = this.eachWs.location.lng
      }
    },
    onedoFold(el) {
      this.unfold = el
    },
    closeAuthModal() {
      this.authModal = false
    },
    today() {
      // 日付をYYYY/MM/DD HH:DD:MI:SS形式で取得
      let date = new Date()
      let yyyy = date.getFullYear()
      let mm = this.toDoubleDigits(date.getMonth() + 1)
      let dd = this.toDoubleDigits(date.getDate())
      let hh = this.toDoubleDigits(date.getHours())
      let mi = this.toDoubleDigits(date.getMinutes())
      let se = this.toDoubleDigits(date.getSeconds())
      let ms = this.toDoubleDigits(date.getMilliseconds())
      this.now = yyyy + mm + dd + hh + mi + se + ms
      // console.log(this.now)
    },
    toDoubleDigits: function (num) {
      num += "";
      if (num.length === 1) {
        num = "0" + num;
      }
      return num;
    },
    getIconWithColor(tagColor, iconType = 'flag') {
      const color = tagColor || '#126fc6';
      const icon = L.divIcon({
        html:
          iconType == 'flag'
            ?
            `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="_x32_" x="0px" y="0px" width="512px" height="512px" viewBox="0 0 512 512" style="width: 32px; height: 32px; opacity: 1;" xml:space="preserve"><g><rect x="144" class="st0" width="320" height="240" style="fill: ${color}" stroke="white" stroke-width="20" stroke-linecap="round""/><rect x="48" class="st0" width="64" height="512" style="fill: ${color}" stroke="white" stroke-width="20" stroke-linecap="round""/></g></svg>`
            :
            `<svg version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="width: 32px; height: 32px; opacity: 1;" xml:space="preserve"><g><path class="st0" d="M256.102,275.689c-13.136,0-26.131-2.015-38.62-5.994l-2.073-0.66v203.275c0,5.792,2.199,11.289,6.227,15.512 l17.453,17.216c4.276,4.488,10.047,6.96,16.246,6.96c6.202,0,11.97-2.473,16.211-6.926l17.525-17.286 c3.992-4.192,6.19-9.685,6.19-15.477V269.556l-2.052,0.625C281.193,273.838,268.709,275.689,256.102,275.689z" style="fill: ${color};"></path><path class="st0" d="M255.999,0c-68.961,0-125.063,56.106-125.063,125.069c0,68.959,56.102,125.065,125.063,125.065 s125.065-56.106,125.065-125.065C381.064,56.106,324.96,0,255.999,0z M217.269,126.047c-20.052,0-36.366-16.312-36.366-36.366 c0-20.05,16.314-36.362,36.366-36.362s36.366,16.312,36.366,36.362C253.635,109.735,237.321,126.047,217.269,126.047z" style="fill: ${color};"></path></g></svg>`
        ,
        iconAnchor: [3, 34],
        className: 'dummy' // これがないとデフォルトのleaflet-div-iconが適用されてしまう
      })
      return icon
    },
    getIdea() { //アイデア取得
      let self = this, oneidea = {}
      this.idea = []
      this.mapLid.forEach((el) => {
        //console.log(el)
        let collection = this.db.collection("0").doc(el).collection("idea").where("isActive", "==", true).where("isHidden", "==", false).where('latlngInputLat', "!=", 0)
        collection.get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            oneidea = doc.data()
            //console.log(oneidea)
            self.$set(oneidea, "id", doc.id)
            self.$set(oneidea, "lidId", el) //どのLidかわかるように
            if (oneidea.isActive) self.idea.push(oneidea)
          })
          self.showedIdeaInMap()
        })
        //console.log("アイデア", this.idea)
      })
    },
    showedIdeaInMap() {
      this.showedIdeaInMap_dict = []
      for (let i = 0; i < this.idea.length; i++) {
        if (this.idea[i].latlngInputLat != 0) {
          this.showedIdeaInMap_dict.push({
            ...this.idea[i],
            icon: this.getIconWithColor(this.idea[i].postcolor)
          })
        }
      }
    },
  }
}
</script>

<style>
.v-date-picker-table.v-date-picker-table--date>table>tbody tr td:nth-child(7) .v-btn__content {
  color: blue;
}

.v-date-picker-table.v-date-picker-table--date>table>tbody tr td:nth-child(1) .v-btn__content {
  color: red;
}
</style>

<style scoped>
.child-sticky{
  position: sticky;
  top: 60px;
  z-index: 2;
}
.pl312 {
  padding-left: 312px !important;
}

.pl80 {
  padding-left: 80px !important;
}

.abyssFont {
  color: #294A66;
}

/* 斜め配置 clip-path */
.Block2 {
  -webkit-clip-path: polygon(100% 15%, 0% 100%, 100% 100%);
  clip-path: polygon(100% 15%, 0% 100%, 100% 100%);
  background-color: #CCE8FF;
  color: #ccc;
  padding: 60px 0 10px 0;
  border-right: none;
  border-left: none;
}

.ideabox {
  position: fixed;
  bottom: 0px;
}

.lidchips .v-slide-group.v-item-group>.v-slide-group__prev {
  display: block !important;
}

p {
  white-space: pre-wrap;
}
</style>
